import { appConfig } from "../../appConfig";
import { getQueryStringToken } from "./getQueryStringToken";

export function loadSessionToken() {
	let token = window.cg_TOKEN || appConfig.token || appConfig.TOKEN;
	if (token == null) {
		token = getQueryStringToken();		
	}
	return token == null? '':token;
}
